import {
  type BubbleChartDataPointModel,
  type BubbleChartViewModelSourceData,
  type BubbleChartViewSettings,
  BubbleChartGridMode,
  DEFAULT_BUBBLE_CHART_VIEW_SETTINGS,
  INITIAL_SOURCE_DATA_STATE,
  INITIAL_VIEW_INTERFACE,
} from '@ardoq/bubble-chart';
import type { BubbleChartRenderSettings } from '@ardoq/api-types';

type BuildBubbleChartSourceDataArgs = BubbleChartRenderSettings & {
  viewInstanceId: string;
  data: BubbleChartDataPointModel[];
};

export const buildBubbleChartSourceData = ({
  viewInstanceId,
  data,
  background,
  customQuadrantSettings,
  showBubblesWithZeroValue,
  xAxisTitle,
  yAxisTitle,
  bubbleAreaScaleFactor,
}: BuildBubbleChartSourceDataArgs): BubbleChartViewModelSourceData => {
  const viewSettings: BubbleChartViewSettings = {
    ...DEFAULT_BUBBLE_CHART_VIEW_SETTINGS,
    background: (background ?? BubbleChartGridMode.NONE) as BubbleChartGridMode,
    customQuadrantSettings:
      customQuadrantSettings ??
      DEFAULT_BUBBLE_CHART_VIEW_SETTINGS.customQuadrantSettings,
    showBubblesWithZeroValue: showBubblesWithZeroValue ?? true,
    bubbleAreaScaleFactor:
      bubbleAreaScaleFactor ??
      DEFAULT_BUBBLE_CHART_VIEW_SETTINGS.bubbleAreaScaleFactor,
  };

  return {
    ...INITIAL_SOURCE_DATA_STATE,
    viewInstanceId,
    viewInterface: INITIAL_VIEW_INTERFACE,
    viewSettings,
    data,
    isLoadingData: false,
    xAxisTitle: xAxisTitle ?? '',
    yAxisTitle: yAxisTitle ?? '',
  };
};
